import * as React from 'react';
import { Form_StringInputProps } from '../../../../../../react-commons/components/form/inputs/Form_StringInput';
import { Inputs } from '../../../../../../react-commons/utils/form/inputs';
import { usePropertyInfo } from '../../../hooks/usePropertyInfo';
import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';

export const Form_PropertyStringInput = <T extends object, N extends boolean>({
    readOnly,
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType, resourceId },
    hideLabel,
    ...props
}: Omit<Form_StringInputProps<T, N>, 'label' | 'labelInfo' | 'severity' | 'helperText' | 'endingIcon'> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    return <Inputs.String
        {...propertyInfo}
        {...props}
        helperText={propertyInfo.helperText ? [propertyInfo.helperText] : undefined}
    />;
};
